<svg xmlns="http://www.w3.org/2000/svg" class="icon" [ngClass]="'icon ' + iconCls" viewBox="0 0 15.585 15.585">
	<path
		class="icon__path"
		d="M104.793,321.539l-7.586-7.586a2.788,2.788,0,0,0-1.707-.707h-5a1,1,0,0,0-1,1v5a2.782,2.782,0,0,0,.707,1.707l7.586,7.586a1,1,0,0,0,1.414,0l5.586-5.586A1,1,0,0,0,104.793,321.539ZM93.5,319.078a1.833,1.833,0,1,1,1.833-1.832A1.832,1.832,0,0,1,93.5,319.078Z"
		transform="translate(-89.5 -313.246)"
	/>
</svg>
